import React from 'react'
import { Footer as FooterCore } from '../Footer'
import { useContext } from './Context'
import isEmpty from 'lodash/isEmpty'
import { useContext as useParentContext } from '../Context'
import { TabName } from '../TabName'

export const Footer = () => {
  const { newTasks } = useContext()
  const { addTask, setNewTasks } = useParentContext()

  const loading = addTask?.loading
  const disabled = isEmpty(newTasks)

  const onSave = async () => {
    //save to parent save task
    setNewTasks(newTasks)

    await addTask?.action({ tasks: newTasks, activeTab: TabName.fromManualAdd })
  }

  return <FooterCore disabled={disabled} onSave={onSave} isBusy={loading} />
}
